import { useState } from 'react';
import { TableRow, IconButton } from '@mui/material';

import { TableBodyCell } from '../table-cells/TableCells';
import Icon from '../Icon';
import RemoveDomain from './RemoveDomain';
import UpdateDomain from './UpdateDomain';

const DomainsListItem = ({ id, domain, groups, users }) => {
  const [isUpdateDialogShow, setUpdateDialogState] = useState(false);
  const [isDeleteDialogShow, setDeleteDialogState] = useState(false);

  const updateDialogHandler = () => {
    setUpdateDialogState((prevState) => !prevState);
  };

  const deleteDialogHandler = () => {
    setDeleteDialogState((prevState) => !prevState);
  };

  return (
    <>
      <TableRow
        key={id}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableBodyCell scope="row">{domain}</TableBodyCell>
        <TableBodyCell align="left">{groups}</TableBodyCell>
        <TableBodyCell align="left">{users}</TableBodyCell>
        <TableBodyCell sx={{ width: '72px' }}>
          <IconButton onClick={updateDialogHandler}>
            <Icon id="edit" />
          </IconButton>
        </TableBodyCell>
        <TableBodyCell sx={{ width: '72px' }}>
          <IconButton onClick={deleteDialogHandler}>
            <Icon id="delete" />
          </IconButton>
        </TableBodyCell>
      </TableRow>
      {isDeleteDialogShow ? (
        <RemoveDomain
          domainId={id}
          domainName={domain}
          onClose={deleteDialogHandler}
        />
      ) : null}
      {isUpdateDialogShow ? (
        <UpdateDomain
          domainId={id}
          domainName={domain}
          onClose={updateDialogHandler}
        />
      ) : null}
    </>
  );
};

export default DomainsListItem;
